import { Injectable } from "@angular/core";
import { RxdbQuoteRepository } from "../../rxdb/repositories/quotes/rxdb-quote.repository";
import { from, Observable } from "rxjs";
import { QuoteSummary } from "../../models/quote/quote-summary";
import { Page } from "../../utils/page";

@Injectable()
export class StandaloneQuoteHistoryService {

    constructor(
        private readonly rxdbQuoteRepository: RxdbQuoteRepository) {
    }

    getStandaloneQuotes(pageable: Map<string, string>): Observable<Page<QuoteSummary>> {
        return from(this.rxdbQuoteRepository.getStandaloneQuotes(pageable));
    }
}